import { SeoMetadata } from '../types'

export const LOCALE_GB = 'en-gb'
export const LOCALE_US = 'en-us'

export const allLocales = [LOCALE_GB, LOCALE_US] as const

export const localeToCountryCode = (locale: string): string => {
  if (locale === LOCALE_GB) return 'GB'
  return 'US'
}

export const WEBSITE_LOCALES = [LOCALE_GB, LOCALE_US] as const

export const WEBSITE_DEFAULT_LOCALE = LOCALE_GB

export type WebsiteLocale = (typeof WEBSITE_LOCALES)[number]

export const LOCALISED_PAGES = ['/', '/buymembership', '/daily30', '/faqs', '/terms', '/zoe-plus'] as const

export const DATOCMS_LOCALES = ['en', 'en_US'] as const

export type DatoCMSLocale = (typeof DATOCMS_LOCALES)[number]

export interface LocaleSupportedPageRecord {
  id: string
  metadata: SeoMetadata
}

export type LocaleSupportedPageRecordCollection = Record<DatoCMSLocale, LocaleSupportedPageRecord>

export type LocalisedPageProps = {
  localisedPages: LocaleSupportedPageRecordCollection
}
